module.exports = __webpack_public_path__ + "img/title_rgm2.ba465178.png";